// extracted by mini-css-extract-plugin
export default {"container":"Navigation_container__CEmkE"};